<template>
  <div>
    <a v-if="isCopy" class="text-left" href="javascript:void(0)" :class="$style.tooltipCss" @mouseenter="showTooltip($event, tooltip ? tooltip : data)" @mouseleave="hideTooltip" v-clipboard:copy="data" v-clipboard:success="() => $toastr.s($i18n.t('common.message.copy'))" v-clipboard:error="() => $toastr.s($i18n.t('common.msgError.copy'))" @click="$emit('click')">
      <i class="fa fa-copy d-inline-block" style="font-size:12px"></i>
      {{ ( data ? data : '-') | truncate(length) }}
    </a>
    <a v-if="isFunction" href="javascript:void(0)" class="mt-2" @mouseenter="showTooltip($event, tooltip ? tooltip : data)" @mouseleave="hideTooltip" @click="$emit('click')">
      {{ ( data ? data : '-') | truncate(length) }}
    </a>
    <a v-if="isDefault" href="javascript:void(0)" class="mt-2" :style="_style" @mouseenter="showTooltip($event, tooltip ? tooltip : data)" @mouseleave="hideTooltip" @click="$emit('click')">
      {{ ( data ? data : '-') | truncate(length) }}
    </a>
    <i v-if="isEdit" class="fa fa-edit ml-2" style="color: #20a8d8; cursor: pointer;" @click="edit"></i>

    <div v-if="tooltipVisible" :style="tooltipStyle" class="tooltip">
      {{ tooltipContent }}
    </div>
  </div>
</template>

<script>
  import i18n from "@/f1/service/i18n";

export default {
  components: {
    i18n,
  },
  props: [ 'data', 'dataLength', 'isCopy', 'isFunction', 'isDefault', 'isModal', 'isEdit', 'textStyle', 'tooltip' ],
  watch: { },
  computed: {
    _style() {
      return `cursor: default; color: black; ${this.textStyle}`
    },
  },
  data: () => {
    return {
      i18n,
      length: 100,
      tooltipContent : '',

      tooltipVisible: false,
      tooltipStyle: {}
    };
  },
  methods: {
    load() {
      return this.length = this.dataLength ? this.dataLength : this.length;
    },
    edit() {
      return this.$emit("edit");
    },

    showTooltip(event, text) {
      if(!text) {
        text = '-';
      }

      this.tooltipContent = text;
      this.tooltipVisible = true;
      this.updateTooltipPosition(event);
    },
    hideTooltip() {
      this.tooltipVisible = false;
    },
    updateTooltipPosition(event) {
      const { top, left, width } = event.target.getBoundingClientRect();
      const tooltipHeight = 40;
      const tooltipWidth = 10;

      this.tooltipStyle = {
        position: 'fixed',
        top: `${ top - tooltipHeight }px`,
        left: `${ left - tooltipWidth / 2 }px`,
        // width: `${ tooltipWidth }%`,
        padding: '5px 10px',
        backgroundColor: 'black',
        color: 'white',
        borderRadius: '4px',
        textAlign: 'center',
        zIndex: 1000,
        pointerEvents: 'none',
        opacity: 1,
        wordWrap: 'break-word'
      };
    }
  },
  created() { console.log('[vue] component data', 'created'); },
  destroyed() { console.log('[vue] component data', 'destroyed'); },
  mounted() { console.log('[vue] component data', 'mounted'); this.load() },
};

</script>

<style module>
.tooltipCss {
  text-decoration: underline;
  font-weight: bold;
  cursor: pointer;
  margin-top: 0.5rem;
}
.tooltip {
  position: absolute;
  background-color: black;
  color: white;
  padding: 5px 10px;
  border-radius: 4px;
  text-align: center;
  z-index: 1000;
  pointer-events: none;
  opacity: 1; /* slight opacity for better visibility */
  word-wrap: break-word;
  max-width: 200px; /* set a max-width to handle long content */
}
</style>
